import tw, { styled } from "twin.macro";

export const Wrapper = styled.div`
	${tw`p-2 bg-white w-full flex flex-col container`}

	input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type="number"] {
		-moz-appearance: textfield;
	}

	box-shadow: 0px 30px 60px rgba(32, 56, 85, 0.05);
	border-radius: 10px;

	@media (max-width: 1217px) {
		height: auto;
	}
`;
